import React,{useState,useEffect} from "react";

import { useDispatch } from "react-redux";

const RangeSliderBorderRadius = ({setSliderVal,sliderVal ,resolution}) => {
  
  
  
    
       const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
            
       
  const [value, setValue] = useState();
     useEffect(()=>{
      setValue(sliderVal?sliderVal:10)
     },[])


     let rangeArr= resolution=="px"?[0,30, 60, 90, 120 , 150 ]:[0,10, 20, 30, 40 , 100 ];
    return (
      <div className="range-slider-basic-two" >
        <input
          type="range"
          min="0"
          max={resolution=="px"?"150":"100"}
          value={value}
          onChange={(e) => {setValue(parseInt(e.target.value)) ;setSliderVal(parseInt(e.target.value))}}
          className="slider-basic-two"
        />
        <div className="marks">
        {rangeArr?.map((mark,index) => (
          <span  onClick={() => {setValue(mark) ;setSliderVal(mark);;}}  onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
            key={mark}
            className={`mark-basic ${value === mark ? '' : ''}`}
            style={{ left: `${index*20}%` }}
          >
            {mark}
          </span>
        ))}
      </div>{/* Marker that moves with thumb */}
  <div
    className={`mark-floating-two ${value ? 'active-basic-two' : ''}`}
    style={{
      left: `${((value - 3) / ( resolution=="px"?150:100)) * 100}%`,
    }}
  >
    {value} {resolution}
  </div>
          </div>
    );
  };
  export default RangeSliderBorderRadius;